import { useProgress } from "@react-three/drei";
import { useEffect, useState } from "react";
import { useSplashStore } from "../stores/useSplashStore";
import { useAudioStore } from "../stores/useAudioStore";

export function Loader() {
  const { isLoading, startExperience, hideSplash } = useSplashStore();
  const { initAudio, playAudio } = useAudioStore();
  const { progress } = useProgress();
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [loadingComplete, setLoadingComplete] = useState(false);
  const [hideLoadingBar, setHideLoadingBar] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    if (progress === 100 && isLoading && !loadingComplete) {
      setLoadingComplete(true);
      setTimeout(() => {
        setHideLoadingBar(true);
      }, 300);
    }
  }, [progress, isLoading, loadingComplete]);

  const handleStart = () => {
    if (hasStarted) return;

    setHasStarted(true);
    initAudio();
    playAudio();
    setIsFadingOut(true);
    startExperience();
    setTimeout(() => {
      hideSplash();
    }, 2100);
  };

  if (!isLoading && !isFadingOut) return null;

  return (
    <div className={`loader ${isFadingOut ? "fade-out" : ""}`}>
      <div className="loader-content">
        {!hideLoadingBar ? (
          <div
            className={
              loadingComplete
                ? "loader-bar-container fade-out-bar"
                : "loader-bar-container"
            }
          >
            <div className="loader-bar">
              <div
                className="loader-progress"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        ) : (
          <span
            className={`loader-start-button ${hasStarted ? "disabled" : ""}`}
            onClick={handleStart}
            style={{
              pointerEvents: hasStarted ? "none" : "auto",
              userSelect: hasStarted ? "none" : "auto",
            }}
          >
            Click here to start the experience
          </span>
        )}
      </div>
    </div>
  );
}
